// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".anon-row{margin-bottom:20px;cursor:pointer}.anon-text{font-size:19px;margin-right:10px;display:inline-block;margin-top:20px}.pointer-el{cursor:pointer}", ""]);
// Exports
module.exports = exports;
